import ProductPage from '../modules/product-page';
import { ViewItemEvent } from '../modules/tracking';

export default {
	init() {
		ProductPage.init();
	},
	finalize() {
		// JavaScript to be fired on all pages, after page specific JS is fired
	},
	cleanup() {
		//
		ProductPage.unload();
	},
};



// WEBPACK FOOTER //
// ./scripts/routes/single-product.js